/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Template_EmptyInputs */

const en_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No template data yet.`)
};

const de_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Vorlagendaten.`)
};

const fr_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée de modèle pour le moment.`)
};

const es_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay datos de plantillas.`)
};

const it_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato sui modelli ancora.`)
};

const nl_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen sjabloongegevens.`)
};

const pl_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych o szablonach.`)
};

const fi_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä mallitietoja.`)
};

const da_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen skabelondata endnu.`)
};

const sv_analytics_template_empty = /** @type {(inputs: Analytics_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen malldata ännu.`)
};

/**
* | output |
* | --- |
* | "No template data yet." |
*
* @param {Analytics_Template_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_template_empty = /** @type {((inputs?: Analytics_Template_EmptyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Template_EmptyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_template_empty(inputs)
	if (locale === "fr") return fr_analytics_template_empty(inputs)
	if (locale === "es") return es_analytics_template_empty(inputs)
	if (locale === "it") return it_analytics_template_empty(inputs)
	if (locale === "nl") return nl_analytics_template_empty(inputs)
	if (locale === "pl") return pl_analytics_template_empty(inputs)
	if (locale === "fi") return fi_analytics_template_empty(inputs)
	if (locale === "da") return da_analytics_template_empty(inputs)
	if (locale === "sv") return sv_analytics_template_empty(inputs)
	return en_analytics_template_empty(inputs)
});